import { usePermissions } from '../contexts/PermissionContext';

export function usePermissionCheck() {
  const { hasPermission, loading, currentResource } = usePermissions();

  return {
    hasPermission,
    isLoading: loading,
    isAdmin: currentResource?.is_admin || false,
    currentResource,
    canAccess: {
      calendar: hasPermission('calendar.pageAccess'),
      calendarSales: hasPermission('calendar.sales'),
      viewAllBookings: hasPermission('calendar.viewAllBookings'),
      bookingInformation: hasPermission('calendar.bookingInformation'),
      bookingSalesInfo: hasPermission('calendar.bookingSalesInfo'),
      editBookingDetails: hasPermission('calendar.editBookingDetails'),
      bookingMaterials: hasPermission('calendar.bookingMaterials'),
      bookingRatebook: hasPermission('calendar.bookingRatebook'),
      bookingProfitLoss: hasPermission('calendar.bookingProfitLoss'),
      bookingLiabilityWaiver: hasPermission('calendar.bookingLiabilityWaiver'),
      messages: hasPermission('messages.pageAccess'),
      crm: hasPermission('crm.pageAccess'),
      marketing: hasPermission('marketing.pageAccess'),
      campaigns: hasPermission('campaigns.pageAccess'),
      salesMap: hasPermission('salesMap.pageAccess'),
      payroll: hasPermission('payroll.pageAccess'),
      timeclock: hasPermission('timeclock.pageAccess'),
      timeAccounting: hasPermission('timeAccounting.pageAccess'),
      accountingHub: hasPermission('accountingHub.pageAccess'),
      invoiceSettings: hasPermission('invoiceSettings.pageAccess'),
      supplies: hasPermission('supplies.pageAccess'),
      services: hasPermission('services.pageAccess'),
      resources: hasPermission('resources.pageAccess'),
      salesReports: hasPermission('salesReports.pageAccess'),
      teamReports: hasPermission('teamReports.pageAccess'),
      suppliesUsage: hasPermission('suppliesUsage.pageAccess'),
      settings: hasPermission('settings.pageAccess'),
      tasks: hasPermission('tasks.pageAccess'),
      bookings: hasPermission('bookings.pageAccess'),
      proposals: hasPermission('proposals.pageAccess'),
      customers: hasPermission('customers.pageAccess'),
      kpiDashboard: hasPermission('kpiDashboard.pageAccess'),
      automations: hasPermission('automations.pageAccess'),
    }
  };
} 